import ReplyForm from './ReplyForm'

export default ReplyForm
